// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ant-dropdown-menu-item {\n  padding: 8px 30px !important;\n  font-size: 15px !important;\n}\n", "",{"version":3,"sources":["webpack://./src/Components/Common/dropdown/DropdownHandle.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,0BAA0B;AAC5B","sourcesContent":[".ant-dropdown-menu-item {\n  padding: 8px 30px !important;\n  font-size: 15px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
